<template>

  <div>
    <b-media
      v-for="(payment, index) in paymentDetails.items"
      :key="index"
      class="mb-1"
      no-body
    >
      <b-media-body>
        <p class="mb-0">
          {{ payment.text }}
        </p>
      </b-media-body>

      <div>
        <p class="mb-0">
          {{ formatCurrency(payment.planning_cost) }}
        </p>
      </div>
    </b-media>

    <b-media
      v-if="paymentDetails.shipping_cost > 0"
      class="mb-1"
      no-body
    >
      <b-media-body>
        <p class="mb-0">
          Envio
        </p>
      </b-media-body>

      <div>
        <p class="mb-0">
          {{ formatCurrency(paymentDetails.shipping_cost) }}
        </p>
      </div>
    </b-media>
    <hr>
    <b-media
      class="mb-3"
      no-body
    >
      <b-media-body>
        <h3 class="mb-0 detail-title detail-total">
          Total
        </h3>
      </b-media-body>

      <div>
        <h3 class="mb-0 detail-amt font-weight-bolder">
          {{ formatCurrency(paymentDetails.total_cost) }}
        </h3>
      </div>
    </b-media>
  </div>

</template>

<script>
import {
  BForm,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BFormInvalidFeedback,
  BInputGroupAppend, BInputGroup, BMediaAside, BMedia, BAvatar, BMediaBody,
} from 'bootstrap-vue'
import { formatCurrency } from '../../../helpers/utils'

export default {
  components: {
    BCard,
    BButton,
    BMediaBody,
    BMedia,
  },
  props: {
    paymentDetails: {
      type: Object,
      required: true,
    },
  },
  methods: { formatCurrency },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
